module.exports = function() {
  return new Worker(__webpack_public_path__ + "ee2ad1a212cb75b5777a.worker.js");
};